import { ca } from '@cian/analytics';

export const trackPaginationClick = (page: number) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'pagination',
    label: page,
  });
};
